import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { SignaturesPage } from "@/features/reporting/components/signatures-page";
import { resolveBoundedPeriod } from "@/features/reporting/lib/period";

const layoutRoute = getRouteApi("/_authed/_dashboard/reporting");

export const Route = createFileRoute("/_authed/_dashboard/reporting/signatures")({
  component: ReportingSignaturesRoute,
});

function ReportingSignaturesRoute() {
  const search = layoutRoute.useSearch();

  return (
    <SignaturesPage
      period={resolveBoundedPeriod("/reporting/signatures", search.period)}
      filters={{ tenantId: search.tenantId, companyId: search.companyId }}
    />
  );
}
